/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const authenticateTelegramRequestSchema = z.object({
  initData: z.string().min(1),
});

export type IAuthenticateTelegramRequest = z.infer<typeof authenticateTelegramRequestSchema>;
